import manifest from './localManufacturerImageManifest.js';

export function localManufacturerImage(source) {
  return manifest.sources[source] || source;
}

// Preserve filename-keyed descriptions after migrating a manufacturer source.
const originalSources = Object.fromEntries(Object.entries(manifest.sources).map(([source, local]) => [local, source]));
export function originalManufacturerImage(source) {
  return originalSources[source] || source;
}

export function localManufacturerSitemapImages(path) {
  return (manifest.pages[path] || []).map(image => `https://1woodfloors.com${image}`);
}